export default __webpack_public_path__ + "static/media/offer4.6f483ab0.jpg";